import React, { useState, useRef, useEffect } from "react";
import DataTable from "react-data-table-component";
import { DefaultImageBaseurl, endPoints } from "../../../constant/Environment";
import { addData, deleteData, getAllData } from "../../../Utility/API";
import { Modal, Form, Button, Dropdown } from "react-bootstrap";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
import { AiTwotoneEyeInvisible, AiFillEyeInvisible } from "react-icons/ai";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import DeleteModel from "../../../components/DeleteModel";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const ReferFriendDailyClaim = () => {
  const [editData, setEditData] = useState({});

  const [creative, setCreative] = useState("");
  const [showcreative, setShowCreative] = useState("");

  const [name, setName] = useState("");
  const [goldCoin, setGoldCoin] = useState("");
  const [sagaCoin, setSagaCoin] = useState("");
  const [description, setDescription] = useState("");

  const [category, setCategory] = useState("");

  const [show, setShow] = useState(false);
  const [rows, setRows] = useState([
    // {
    //   name: "Refer A friend",
    //   sagacoins: 10,
    //   isactive: 1,
    //   goldcoins: 100,
    //   creative: "",
    // },
  ]);
  const [multiplier, setMultiplier] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleClose = () => setShow(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  // console.log("excludePackage", excludePackage);

  const [checkboxes, setCheckboxes] = useState({
    isCheckedActive: false,
    isFeature: false,
    isPopular: false,
    isSpecial: false,
  });
  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [name]: checked,
    }));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setCreative(file);
      setShowCreative(imageUrl);
      UploadImage(file);
    }
  };

  const UploadImage = (files) => {
    var formdata = new FormData();
    formdata.append("file", files);
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };
    setIsLoading(true);
    let imgUrl = `${endPoints.apiBaseUrl}${endPoints.api.UPLOAD_BANNER}`;
    fetch(imgUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setCreative(result.data);
        setIsLoading(false);
      })
      .catch((error) => console.log("error", error));
  };

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    // api call
    fetchConfiguration();
  }, []);

  const fetchConfiguration = async () => {
    let url = `${endPoints.api.CONFIGURATION}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          setRows(response.data);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const handleOk = () => {
    if (name && goldCoin && sagaCoin && creative && category) {
      let url = editData?.id
        ? `${endPoints.api.CONFIGURATION_UPDATE}`
        : `${endPoints.api.CONFIGURATION_CREATE}`;

      let payload = {
        conf_name: category,
        name: name,
        icon: creative,
        gc_coin: goldCoin,
        sc_coin: sagaCoin,
        isActive: checkboxes.isCheckedActive ? 1 : 0,
        description: description,
        multplier: multiplier,
      };
      console.log(payload);
      if (editData?.id) {
        payload.id = editData.id;
      }
      setIsLoading(true);
      addData(url, payload)
        .then((response) => {
          setIsLoading(false);
          if (response.data.status === "success") {
            SuccesToast(response?.data?.message);
            fetchConfiguration();

            handleClose();
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.error(error);
          ErrorToast(error);
        });
    } else {
      ErrorToast("all fields are required");
    }
  };

  useEffect(() => {
    if (editData) {
      let imageFullPath =
        editData.icon !== undefined
          ? `${endPoints.apiBaseUrl}${editData.icon}`
          : "";
      setName(editData.name || "");
      setCategory(editData.conf_name || "");
      setCreative(editData.icon || "");
      setShowCreative(imageFullPath || "");
      setGoldCoin(editData.gc_coin || "");
      setSagaCoin(editData.sc_coin || "");
      setMultiplier(editData.multplier || ""); 
      setCheckboxes((prevCheckboxes) => ({
        ...prevCheckboxes,
        isCheckedActive: editData.isActive || false,
      }));
    }
  }, [editData]);

  const handleSwitchChange = (row, param, value) => {
    // `value` (row.isActive) comes back as a Boolean from the API, so `value === 0`
    // was always false and toggling on never worked. Normalise: truthy -> 0, falsy -> 1.
    const updatedRow = { ...row, [param]: value ? 0 : 1 };
    updateConfiguration(updatedRow);
  };

  const updateConfiguration = (payload) => {
    const id = payload.id;
    let url = `${endPoints.api.CONFIGURATION_UPDATE}`;
    setIsLoading(true);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          fetchConfiguration();

          handleClose();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  };

  const rowsToDisplay = rows;

  const preDefinedName = [
    {
      id: "refer_friend",
      name: "Refer A Friend",
    },
    {
      id: "daily_bouns",
      name: "Free Daily Rewards",
    },
    {
      id: "signup_bouns",
      name: "SignUp",
    },
    {
      id: "promo_bouns",
      name: "Promo",
    },
    {
      id: "social_media",
      name: "Social Media",
    },
    {
      id: "mailing",
      name: "Mailing",
    },
    {
      id: "birthday_bonus",
      name: "Birthday Bonus",
    },
    {
      id: "daily_login_streak",
      name: "Daily Login Streak",
    },
    {
      id: "rakeback",
      name: "Rakeback"
    },
    {
      id: "other_bouns",
      name: "Other",
    },
  ];

  return (
    <>
      <div className="main">
        <Toaster></Toaster>

        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div
                  className="col-md-12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #444",
                  }}
                >
                  <h3
                    className="mb-2 heading-table"
                    style={{ fontFamily: "ArticulatCF-Bold" }}
                  >
                    Configuration
                  </h3>
                </div>
              </div>

              <div style={{ marginTop: "10px" }}>
                <div className="row">
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        stickyHeader
                        sx={{ minWidth: 500 }}
                        aria-label="custom pagination table"
                      >
                        <TableHead>
                          <TableRow>
                            {/* <TableCell align="center"> Category</TableCell> */}
                            <TableCell align="center"> Name</TableCell>
                            <TableCell align="center">Gold Coins </TableCell>
                            <TableCell align="center">Saga Coins</TableCell>
                            <TableCell align="center">Icon</TableCell>
                            <TableCell align="center">Multiplier</TableCell>
                            <TableCell align="center">Active</TableCell>
                            <TableCell align="center">Options</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rowsToDisplay
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((row) => (
                              <TableRow
                                key={row.id}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                {/* <TableCell align="center">
                                  {row.conf_name}
                                </TableCell> */}
                                <TableCell align="center">{row.name}</TableCell>
                                <TableCell align="center">
                                  {row.gc_coin}
                                </TableCell>
                                <TableCell align="center">
                                  {row.sc_coin}
                                </TableCell>

                                <TableCell align="center">
                                  <img
                                    src={`${DefaultImageBaseurl}${row.icon}`}
                                    style={{ height: "50px" }}
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  {row?.multplier}x
                                </TableCell>

                                <TableCell align="center">
                                  <Switch
                                    // checked={row.isActive !== 0}
                                    checked={row.isActive}
                                    onChange={() =>
                                      handleSwitchChange(
                                        row,
                                        "isActive",
                                        row.isActive
                                      )
                                    }
                                  />
                                </TableCell>

                                <TableCell align="center">
                                  <EditIcon
                                    onClick={() => {
                                      setShow(true);

                                      setEditData(row);
                                    }}
                                  />
                                </TableCell>
                              </TableRow>
                            ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: "All", value: -1 },
                              ]}
                              colSpan={12}
                              count={rowsToDisplay.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                  <>
                    <Modal show={show} onHide={handleClose} size="lg">
                      <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                          Manage Configuration
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Group className="mb-3">
                              <Form.Label>Category </Form.Label>
                              <Form.Select
                                value={category}
                                onChange={(event) =>
                                  setCategory(event.target.value)
                                }
                              >
                                <option value="">Select Option</option>
                                {preDefinedName.map((item, index) => {
                                  return (
                                    <option key={index} value={item.id}>
                                      {item.name}
                                    </option>
                                  );
                                })}
                              </Form.Select>
                            </Form.Group>
                          </div>
                          <div className="col-md-6"></div>
                          <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label> Name </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Name"
                                value={name}
                                onChange={(event) => {
                                  setName(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>

                          <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Description </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter Description"
                                value={description}
                                onChange={(event) => {
                                  setDescription(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>

                          <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Gold Coin </Form.Label>
                              <Form.Control
                                type="number"
                                placeholder="Gold Coin"
                                value={goldCoin}
                                onChange={(event) => {
                                  setGoldCoin(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>

                            <div className="col-md-6">
                            <Form.Group className="mb-3">
                              <Form.Label>Multiplier </Form.Label>
                              <Form.Select
                                value={multiplier}
                                onChange={(event) =>
                                  setMultiplier(event.target.value)
                                }
                              >
                                <option value="">Select Multiplier</option>
                                {Array.from({ length: 5 }, (_, index) => (
                                  <option key={index + 1} value={index + 1}>
                                    {index + 1}x
                                  </option>
                                ))}
                              </Form.Select>
                            </Form.Group>
                          </div>
                          

                          <div className="col-md-6">
                            <Form.Group className="mb-3" controlId="game">
                              <Form.Label>Upload Creative </Form.Label>
                              <Form.Control
                                type="file"
                                placeholder="Upload Creative"
                                onChange={handleFileChange}
                              />
                            </Form.Group>
                          </div>

                          <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Saga Coin</Form.Label>
                              <Form.Control
                                type="number"
                                placeholder="Saga Coin"
                                value={sagaCoin}
                                onChange={(event) => {
                                  setSagaCoin(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            {showcreative && (
                              <div>
                                <img
                                  src={showcreative}
                                  alt="Selected"
                                  style={{ maxWidth: "100px" }}
                                />
                              </div>
                            )}
                          </div>

                          <div className="col-md-3">
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    name="isCheckedActive"
                                    checked={checkboxes.isCheckedActive}
                                    onChange={handleCheckboxChange}
                                  />
                                }
                                label="Active"
                              />
                            </FormGroup>
                          </div>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          onClick={handleOk}
                          style={{
                            background: "#04631e",
                            borderColor: "#04631e",
                          }}
                        >
                          Apply
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginTop: "20px",
                }}
              >
                <Button
                  variant="primary"
                  style={{ background: "#04631e", borderColor: "#04631e" }}
                  onClick={() => {
                    setShow(true);
                    setEditData({});
                  }}
                >
                  Add New Data
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReferFriendDailyClaim;
